/**
 * SupportCategory enum
 *
 * Groups the entries in `SupportUtils.items` by topic so the Support list
 * page can render a category label above each item title.
 *
 * Numeric ordinals match Flutter's declared enum order at
 * `lib/presentation/utils/support_utils.dart:119-128` — preserving the
 * ordinals keeps the web parity contract with any future code that
 * (de)serializes a `SupportCategory` value by index.
 */
export enum SupportCategory {
    account = 0,
    appUsage = 1,
    premium = 2,
    wallet = 3,
    privacy = 4,
    privacyPolicy = 5,
    report = 6,
    supportRequest = 7,
}
